<template>
  <div class="formRejectWrapper">
    <p>Indícanos el motivo del rechazo de la cotización</p>
    <section class="radioWrapper">
        <b-field :key="reason.id" v-for="reason in listReasons" >
            <b-radio v-model="radio"
                :native-value="reason.id"
                type="is-success">
                {{reason.description}}
            </b-radio>
        </b-field>
    </section>
    <p>Coméntanos sobre el motivo de rechazo seleccionado <span v-show="textRequired()">(*)</span> </p>
    <section>
        <b-field>
            <b-input v-model="text" maxlength="500" type="textarea" :required="textRequired()"></b-input>
        </b-field>
    </section>
    <b-button @click="submit" type="primary" :disabled="disabled()">Enviar</b-button>
  </div>
</template>

<script>
import { updateProductData } from "@/services/services.js";
export default {
  name:"ReasonsRejection",
  props: {
    listReasons: Array,
    action: String,
    quotationId: String
  },
  data() {
      return {
          radio: null,
          text: ""
      }
  },
  mounted() {
    console.log("lista", this.listReasons)
  },
  methods: {
    disabled() {
      if ( this.textRequired() ){
        if( this.radio && this.text) {
          return false
        }
      } else if ( this.radio ){
        return false
      }
      return true
    },
    textRequired() {
      if ( this.radio === this.listReasons[this.listReasons.length-1].id){
        return true
      }
      return false
    },
    submit() {
        let data = {
          'action': this.action,
          'reason_id': this.radio
      }
      if( this.radio === this.listReasons[this.listReasons.length-1].id) {
        console.log("añadio texto", this.listReasons[this.listReasons.length-1])
        data['text'] = this.text
      }else if (this.text) {
        data['text'] = this.text
      }
      const loader = this.$buefy.loading.open();
        updateProductData(this.quotationId, data).then((response) => {
          if (response.status == 200) {
              loader.close()
              this.$router.push("/quotation/post/confirm")
          }
        }).catch((error) => {
            loader.close()
            this.isLoading = false;
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.formRejectWrapper {
  margin-left: 30px;
}
.radioWrapper {
  margin-top: 20px;
}

</style>
